import type { JSX } from "solid-js";

interface VerticalSwitchProps {
	checked: boolean;
	onChange: (next: boolean) => void;
	label?: string;
	class?: string;
}

export function VerticalSwitch(props: VerticalSwitchProps): JSX.Element {
	function toggle() {
		props.onChange(!props.checked);
	}

	function onKeyDown(e: KeyboardEvent) {
		if (e.key === " " || e.key === "Spacebar" || e.key === "Enter") {
			e.preventDefault();
			toggle();
		}
	}

	return (
		<div
			class={`v-switch${props.checked ? " v-switch-on" : ""}${props.class ? ` ${props.class}` : ""}`}
			role="switch"
			aria-checked={props.checked}
			tabIndex={0}
			onClick={toggle}
			onKeyDown={(e) => onKeyDown(e as unknown as KeyboardEvent)}
			aria-label={props.label}
		>
			{props.label && <span style={{ "padding-right": "6px" }}>{props.label}</span>}
		</div>
	);
}
